// Same rule as the menu (Layout.js) and the backend's requirePermission:
// super_admin may do everything; other users need the permission row of the
// resource with the action's column set.
const ACTION_COLUMN = {
  view: 'can_view',
  create: 'can_create',
  update: 'can_edit',
  delete: 'can_delete',
  approve: 'can_approve',
};

export const can = (user, resource, action = 'view') => {
  if (!user) return false;
  if (user.role === 'super_admin') return true;
  const column = ACTION_COLUMN[action];
  if (!column || !Array.isArray(user.permissions)) return false;
  const row = user.permissions.find((p) => p.resource === resource);
  return Boolean(row && row[column] === true);
};

export default can;
